import { Status, TeamMessageReceiverType } from "@shared/enums";
import { CommonEditContext, CreateCommonSearchContext } from "./common-data.model";

export const DefaultTeamMessageModel = {
  search: CreateCommonSearchContext(),
  teamMessageReadSearch: CreateCommonSearchContext(),

  edit: {
    editForm: {
      model: {} as TeamMessageEditCriteria,
      dirty: false,
      status: null as any,
      errors: null as any
    },
  } as CommonEditContext<TeamMessageEditCriteria>,
}

export interface TeamMessageEditCriteria {
  teamMessage_Id: number;
  title: string;
  body: string;
  status: Status;
  teamMessageReceiverType: TeamMessageReceiverType;
  country: string;
  attachment: string;

  subRegion_Id: number;
  terminal_Ids: number[];
  driverTerminals: number[];
  driver_Ids: number[];
}
